import axios from 'axios';

async function postCommit(commit) {
  axios.defaults.headers.common['X-WP-Nonce'] = window._nonce;
  return await axios.post('/wp-json/coolfood/v1/coolfooder_commit', commit);
}

async function postUser(user) {
  axios.defaults.headers.common['X-WP-Nonce'] = window._nonce;
  return await axios.post('/wp-json/coolfood/v1/coolfooder', user);
}

// useEffect(() => {
//   setToken(login());
// }, []);

// const [token, setToken] = useState();

// const login = async () => {
//   try {
//     const response = await axios.post(`/wp-json/jwt-auth/v1/token`, {
//       username,
//       password
//     });
//     if (
//       response.request &&
//       response.request.responseURL &&
//       (response.request.responseURL.match(/invalid/) ||
//         response.request.responseURL.match(/incorrect/))
//     ) {
//       return null;
//     } else {
//       axios.defaults.headers.common.Authorization = `Bearer ${
//         response.data.token
//       }`;
//       return response.data.token;
//     }
//   } catch (error) {
//     console.error('auth error: ', error);
//   }
// };

const postJson = json => {
  switch (json.action) {
  case 'ADD_COMMITS':
    // console.log({
    //   ...json.data,
    //   action: json.action,
    //   ts_disabled: json.ts_disabled
    // });
    return postCommit({
      ...json.data,
      action: json.action,
      ts_disabled: json.ts_disabled
    });
  case 'ADD_USER':
    // console.log({
    //   ...json.data,
    //   action: json.action,
    //   ts_disabled: json.ts_disabled
    // });
    return postUser({
      ...json.data,
      action: json.action,
      ts_disabled: json.ts_disabled
    });
  default:
    console.error('Sync action not recognized');
  }
};

export default postJson;
